export enum UserStatusEnum {
  DENIED = 0, //userCenter.requestStatus = false
  HCP_NOT_VALIDATED = 1, //userRequest => pending (idRole = Employee)
  MANAGER_NOT_VALIDATED = 2, //userRequest => pending (idRole = Manager)
  NO_CENTER = 3, //!userCenter || userCenter.status = false
  ACCEPTED_EMPLOYEE = 4,
  ACCEPTED_MANAGER = 5,
  ACCOUNT_NOT_VALIDATED = 6,
  STAFF_NOT_VALIDATED = 7,
}

export enum UserAccountStatusEnum {
  DENIED = 1,
  PENDING = 2,
  GRANT = 3,
  HUB = 4,
  PROFILING = 5, // Users GRANT + completed modal profiling newsletter
  WAITING_DERMO_INFO = 6,
}

export enum UserTypeEnum {
  HCP = 'Medico',
  STAFF = 'Staff',
}

export enum ConsumerAccountStatusEnum {
  NOT_FOUND = 0,
  NOT_VALIDATED = 1, // Not registered and not validated
  VALIDATED = 2, // Validated and not registered
  REGISTERED = 3, // Registered and not validated
  REGISTERED_AND_VALIDATED = 4,
  WAITING_DERMO_INFO = 6,
}

export enum UserSpecialtyEnum {
  FRIEND = 1,
  LOVER = 2,
}

export enum UserBannerProfiling {
  PROFILE_ONLY = 1,
  NOT_IN_PROFILE = 2,
  HIDE_BANNER = 3,
}
